/**
 * @deprecated Use AppRouter instead
 */
export class ExternalFrontendRouter<Routes extends string = string> {
    private readonly baseUrlWithoutSlash: string;

    public constructor(baseUrl: string) {
        this.baseUrlWithoutSlash = baseUrl.endsWith('/') ? baseUrl.substring(0, baseUrl.length - 1) : baseUrl;
    }

    public get(subPath: Routes, extraRoute?: string): string {
        return `${this.baseUrlWithoutSlash}${subPath}${extraRoute ?? ''}`;
    }

    public getWithParams(subPath: Routes, queryParams?: Record<string, string[] | string>): string {
        let path = this.get(subPath);
        if (queryParams && Object.keys(queryParams).length > 0) {
            const urlParams = new URLSearchParams(queryParams);
            path += `?${urlParams.toString()}`;
        }

        return path;
    }
}
